import React from 'react';
import CreateBookComponent from '../../components/CreateBookComponent/CreateBookComponent';

function CreateBookPage() {
  return <CreateBookComponent />;
}

export default CreateBookPage;
